/**
 * @fileOverview Find scroll parent
 */

export default (node?: HTMLElement): HTMLElement => {
	if (!node) {
		return document.documentElement;
	}

	const excludeStaticParent = node.style.position === "absolute";
	const overflowRegex = /(scroll|auto)/;
	let parent: HTMLElement = node;

	while (parent) {
		if (!parent.parentNode) {
			return (node.ownerDocument as any).documentElement || document.documentElement;
		}

		const style = window?.getComputedStyle(parent);
		const position = style.position;
		const overflow = style.overflow;
		const overflowX = style.overflowX;
		const overflowY = style.overflowY;

		if (position === "static" && excludeStaticParent) {
			continue;
		}

		if (overflowRegex.test([overflow, overflowX, overflowY].join(""))) {
			return parent;
		}

		parent = parent.parentNode as HTMLElement;
	}

	return (node.ownerDocument as any).documentElement || document.documentElement;
};
